import React, { useContext } from 'react';
import { ElementConfigType, PageEditorStoreContext } from '../store/PageEditorStore';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';

type Props = ElementConfigType;

export const PdfButtonComponent: MyComponentType<Props> = (props: Props) => {
  const { privateSchema, styles } = props;
  const pageEditorStore = useContext(PageEditorStoreContext);

  return (
    <div style={styles} className="w-full flex flex-row items-center mb-2.5 color text-black">
      <a
        className="w-full rounded-sm flex flex-row items-center"
        href={
          // eslint-disable-next-line no-script-url
          pageEditorStore.isDevelopment ? '#' : privateSchema?.src?.[0]?.mediaSrc || props.config.src
        }
        target={pageEditorStore.isDevelopment ? '' : '_blank'}
        rel="noreferrer"
        style={{
          border: '1px solid #ccc',
          padding: '6px 15px',
          textDecoration: 'underline',
        }}
      >
        <img
          src="https://cdn.shopify.com/s/files/1/2710/8782/files/cloud_download-fill_60x60.png"
          width="20"
          height="20"
          style={{ marginRight: '10px' }}
        />
        <span>{privateSchema?.src?.[0]?.name || props.config.name}</span>
      </a>
    </div>
  );
};

PdfButtonComponent.definition = {
  // id: 'pdf-button-component',
  id: ComponentIdEnum.PDF_BUTTON_COMPONENT,
  name: 'PDF按钮组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/SYU9ROwKaFaLxDHNVgeMi.png?image_process=resize,w_200',
  position: 11, // 显示顺序
  config: {
    name: 'Assembly Instructions For Triple Motor L-Shaped Standing Desk',
    // eslint-disable-next-line max-len
    src: 'https://cdn.shopify.com/s/files/1/2710/8782/files/Assembly_Instructions_For_Triple_Motor_L-Shaped_Standing_Desk_With_3_Drawers.pdf?v=1649940124',
  },
  styles: {},
  privateSchema: {},
  schema: [],
};
